var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoneStepBankAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4816_77820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2223 35.5557V23.1112M14.2223 35.5557H12.4445M14.2223 35.5557H20.4446M33.7779 35.5557V23.1112M33.7779 35.5557H27.5557M33.7779 35.5557H35.5557M27.5557 35.5557V23.1112M27.5557 35.5557H20.4446M20.4446 35.5557V23.1112M33.1271 20.0307L26.4195 13.8022C25.272 12.7367 24.6982 12.2039 24.0001 12.2039C23.302 12.2039 22.7282 12.7367 21.5807 13.8022L14.8731 20.0307C13.4713 21.3324 12.7704 21.9833 12.9919 22.5472C13.2133 23.1112 14.1698 23.1112 16.0828 23.1112H31.9174C33.8304 23.1112 34.7869 23.1112 35.0083 22.5472C35.2298 21.9833 34.5289 21.3324 33.1271 20.0307Z",
    stroke: "#707070",
    strokeWidth: 1.77778,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4816_77820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoneStepBankAccount);
export default __webpack_public_path__ + "static/media/undone-step-bank-account.20b01d2a81c3a05006a95553a3c03c74.svg";
export { ForwardRef as ReactComponent };